export default {
  namespaced: true,

  state: {
    additions: {},
  },

  getters: {
    additions: (state) => state.additions,
  },

  actions: {
    //
  },

  mutations: {
    updateAdditionsField(state, [name, value]) {
      state.additions[name] = value;
    },
  },
};
